var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{staticClass:"justify-center align-center fill-height"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.color,"size":_vm.size}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }